export default __webpack_public_path__ + "static/media/scotiabank.a08cf4c4.png";